<template>
  <div class="expert-container">
    <h2>{{title}}</h2>
    <div v-if="list.length">
      <div class="expert-list">
        <template v-for="(item, index) in list">
          <list-item :key="index" :info="item"></list-item>
        </template>
      </div>
      <!-- 分页 -->
      <pagination v-show="total>0" :total="total" :page.sync="pageParams.pageNumber" :pageSizes="[4, 10, 20, 30]" :limit.sync="pageParams.pageSize" @pagination="getPageData" />
    </div>
    <div class="none-result" v-else>
      暂无{{title}}信息
    </div>
  </div>
</template>

<script>
import { contentFinds } from "@/api/common/content";
import ListItem from "./components/listItem";
export default {
  data() {
    return {
      title: "",
      list: [],
      total: 0,
      queryBean: {
        contentBean: {
          type1: "专家学者",
          type2: "",
        },
      },
      pageParams: {
        pageNumber: 1,
        pageSize: 4,
        sort: "priority, publish_time",
        order: "desc"
      },
    }
  },
  props: {

  },
  components: {
    ListItem
  },
  watch: {
    $route: {
      handler() {
        this.initPage();
      }
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      let { title } = this.$route.meta;
      this.title = title;
      this.queryBean.contentBean.type2 = title;
      this.getPageData();
    },

    getData(params) {
      let data = Object.assign({}, this.pageParams, this.queryBean, params || {});
      return new Promise(async (resolve, reject) => {
        const res = await contentFinds(data);
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    },
    getPageData() {
      this.getData().then(res => {
        this.list = res.list;
        this.total = res.total;
      })
    }
  },
}
</script>

<style lang="less" scoped>
.expert-container {
  h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #212529;
    margin-bottom: 30px;
  }

  .expert-list {
    display: flex;
    justify-content: flex-start;
    gap: 30px;
    flex-wrap: wrap;
  }

  .none-result {
    text-align: center;
    font-size: 16px;
    color: #999;
    line-height: 60px;
    margin: 30px;
  }
}

@media screen and (max-width: 768px) {
  .expert-container {
    .expert-list {
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: 20px;
      flex-wrap: wrap;
    }
  }
}
</style>